import { Component } from 'react';
import { logger } from '../../util/logger';
import { MESSAGES, DEFAULT_LOCALE } from '../../i18n/messages';

function tSafe(key) {
  // Error boundaries can render before / during provider teardown, so we
  // bypass the context and look the message up directly. Prefers the locale
  // stored for this user, falls back to English.
  try {
    const stored = window.localStorage.getItem('writeon:locale');
    const bundle = MESSAGES[stored] ?? MESSAGES[DEFAULT_LOCALE];
    return bundle[key] ?? MESSAGES[DEFAULT_LOCALE][key] ?? key;
  } catch {
    return MESSAGES[DEFAULT_LOCALE][key] ?? key;
  }
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    logger.error('react_error_boundary', {
      message: error?.message,
      componentStack: info?.componentStack,
    });
  }

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return (
        <div
          role="alert"
          className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center"
        >
          <h1 className="text-2xl font-semibold mb-2 text-text">
            {tSafe('error_boundary.title')}
          </h1>
          <p className="text-secondText mb-6 max-w-md">
            {tSafe('error_boundary.body')}
          </p>
          <button
            type="button"
            onClick={this.handleReset}
            className="app-button-primary"
          >
            {tSafe('error_boundary.retry')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
